export const MOBILE_BANNER_TITLE = 'Лендинг_в_приложении_быстрее_и_удобнее';
export const defaultUrl = 'https://cian.onelink.me/2426377992';
